import React, { useEffect } from "react"
import {useTranslation} from "react-i18next"
import { compose } from "redux"
import {Box, Tab, Tabs, useMediaQuery, useTheme} from "@material-ui/core"

// Components
import ConclusionSection from "../ConclusionSection"
import GeneralInfoSection from "../GeneralInfoSection"
import CommonParametersSection from "../CommonParametersSection"

// Styles
import useStyles from "./styles"
import SignalsCanvasContainer from "../SignalsCanvasContainer"
import RecordLeadsData from "../RecordLeadsData"
import withApproveDialog, { WithApproveDialogProps } from "../../hoc/withApproveDialog"
import withRecordData, { WithRecordDataProps } from "../../hoc/withRecordData"
import ECGGraph from "../ECGGraph"

const TABS = ["conclusion", "info"];

function RecordDetailsSectionMobile(props: WithApproveDialogProps & WithRecordDataProps) {
    const theme = useTheme();
    const styles = useStyles();
    const [t] = useTranslation("common");
    const [currentTab, setCurrentTab] = React.useState(TABS[0]);
    const tabletScreen = useMediaQuery(theme.breakpoints.up("xs"));
    //const {
        //toggleGraph
    //} = props;

    return (
        <div className={styles.container}>
            <Tabs width="100%"
                  value={currentTab}
                  centered={tabletScreen}
                  className={styles.tabs}
                  indicatorColor="primary"
                  onChange={(_, tab) => setCurrentTab(tab)}>
                {TABS.map((key, _, array) => (
                    <Tab key={key}
                         value={key}
                         className={styles.tab}
                         label={t(`records.tab.${key}`)}
                         style={{width: `${100 / array.length}%`}}/>
                ))}
            </Tabs>
            <Box className={styles.tabs_content}>
                {currentTab === TABS[0] && <ConclusionSection/>}
                {currentTab === TABS[1] && (
                    <React.Fragment>
                        <GeneralInfoSection/>
                        <CommonParametersSection/>
                    </React.Fragment>
                )}
            </Box>
            <Box className={styles.signal_section}>
                <div className={styles.signal_container}>

                        <ECGGraph/>
                </div>
            </Box>
        </div>
    )
}

export default compose(
    withApproveDialog,
    withRecordData,
)(RecordDetailsSectionMobile);
